export type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night';

export const getCurrentTimeOfDay = (): TimeOfDay => {
  const currentHour = new Date().getHours();

  if (currentHour >= 6 && currentHour < 12) {
    return 'morning';
  } else if (currentHour >= 12 && currentHour < 18) {
    return 'afternoon';
  } else if (currentHour >= 18 && currentHour < 22) {
    return 'evening';
  } else {
    return 'night';
  }
};
export const isActivityTimeValid = (activityTimeOfDay: string): boolean => {
  const currentTimeOfDay = getCurrentTimeOfDay();
  return activityTimeOfDay === currentTimeOfDay;
};

export const hasActivityTimePassed = (activityTimeOfDay: string): boolean => {
  const currentTimeOfDay = getCurrentTimeOfDay();
  const timeOrder: Record<TimeOfDay, number> = {
    'morning': 0,
    'afternoon': 1,
    'evening': 2,
    'night': 3
  };

  const currentOrder = timeOrder[currentTimeOfDay];
  const activityOrder = timeOrder[activityTimeOfDay as TimeOfDay];
  if (activityOrder === undefined) return false;
  return activityOrder < currentOrder;
};
